export default __webpack_public_path__ + "static/media/xsolDropdown.05bc1d90.svg";